export const ExternalLinkSVG = ({ className }: { className?: string }) => {
    return (
        <svg
            data-testid="external-link-icon"
            className={className}
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.33463 11.3327H2.0013C1.64768 11.3327 1.30854 11.1922 1.05849 10.9422C0.808444 10.6921 0.667969 10.353 0.667969 9.99935V2.66602C0.667969 2.31239 0.808444 1.97325 1.05849 1.72321C1.30854 1.47316 1.64768 1.33268 2.0013 1.33268H4.66797V2.66602H2.0013V9.99935H9.33463V7.33268H10.668V9.99935C10.668 10.353 10.5275 10.6921 10.2774 10.9422C10.0274 11.1922 9.68826 11.3327 9.33463 11.3327ZM5.8013 7.13735L4.8613 6.19468L9.05663 1.99935H6.66797V0.666016H11.3346V5.33268H10.0013V2.94268L5.8013 7.13735Z"
                fill="#205EAC"
            />
        </svg>
    );
};
